import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

export const creatorEnabled = Boolean(process.env.REACT_APP_API_CREATOR_URL);
export const creatorMcpUrl = `${process.env.REACT_APP_API_CREATOR_URL || ''}/mcp`;
const CreatorAPI = axios.create({ baseURL: process.env.REACT_APP_API_CREATOR_URL, responseType: 'json', timeout: 25000 });
CreatorAPI.interceptors.request.use(async config => {
  if (!creatorEnabled) throw new Error('Creator sessions are not configured for this Dashboard.');
  const session = await fetchAuthSession();
  config.headers.Authorization = `Bearer ${session.tokens.accessToken.toString()}`;
  return config;
});
export default CreatorAPI;
